import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSectionColumn';
import InputBox from '../../components/Modal/InputBox';
import ModalButtons from '../../components/Modal/ModalButtons';
import ShareFileSkeleton from '../../components/Skeletons/ShareFileSkeleton';
import { SHARE_FILE_EXCHANGE_RESET } from '../../redux/constants/folderConstants';

const ShareFileModal = ({ data }) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const {
		shareFileModal,
		setShareFileModal,
		shareFilePasswordInput,
		setShareFilePasswordInput,
		handleShareFile
	} = data;

	const shareFile = useSelector((state) => state.shareFile);

	useEffect(
		() => {
			if (shareFile && !shareFile.loading && shareFile.error) {
				setShareFilePasswordInput((prevData) => ({ ...prevData, error: shareFile.error }));
			}
		},
		[ shareFile, setShareFilePasswordInput ]
	);

	const onModalClose = () => {
		setShareFileModal({ file: {}, status: false });
		setShareFilePasswordInput({ value: '', error: '' });

		dispatch({ type: SHARE_FILE_EXCHANGE_RESET });
	};

	return (
		<Modal show={shareFileModal.status}>
			{shareFile && shareFile.loading ? (
				<ShareFileSkeleton fileProtected={shareFileModal.file.protected} />
			) : shareFile && shareFile.file && shareFile.file.link ? (
				<Fragment>
					<div className='modal__heading--container'>
						<a
							href={`/#/share-file?file=${shareFileModal.file._id}&link='${encodeURIComponent(shareFile.file.link)}'`}
							target='_blank'
							rel='noreferrer'
							className='modal_share_heading'>
							{t('screens.fileExchange.shareFileWith', { name: shareFileModal.file.name })}
						</a>
					</div>
					<div className='share-link-container'>
						<p>{`${window.location.hostname}:${window.location.port}/#/share-file?file=${shareFileModal.file
							._id}&link='${encodeURIComponent(shareFile.file.link)}'`}</p>
						<CopyToClipboard
							text={`${window.location.hostname}:${window.location.port}/#/share-file?file='${shareFileModal.file
								._id}'&link='${encodeURIComponent(shareFile.file.link)}'`}
							onCopy={() => {
								toast.success(t('screens.fileExchange.linkCopied'));
								onModalClose();
							}}>
							<button className='share-button'>{t('screens.fileExchange.copy')}</button>
						</CopyToClipboard>
					</div>
					<p className='modal__subtext'>{t('screens.fileExchange.linkValid24')}</p>
					<div className='modal__actions'>
						<button className='modal__button--cancel' onClick={onModalClose}>
							Cancel
						</button>
					</div>
				</Fragment>
			) : (
				<Fragment>
					<ModalHeading heading={t('screens.fileExchange.shareFileTitle', { name: shareFileModal.file.name })} />
					<ModalForm style={{ marginBottom: '2.5rem' }}>
						<InputsSection style={{ width: '34rem' }}>
							{shareFileModal.file.protected ? (
								<InputBox
									label={t('screens.fileExchange.enterPasswordToShare')}
									type='password'
									placeholder='••••••••••••••••'
									value={shareFilePasswordInput.value}
									onChange={(event) => {
										setShareFilePasswordInput({ value: event.target.value, error: '' });
									}}
									errorMessage={shareFilePasswordInput.error}
									style={{ width: '30rem' }}
								/>
							) : (
								<p className='modal__subtext' style={{ margin: '0', marginBottom: '0' }}>
									{t('screens.fileExchange.clickShareBtn')}<br />{t('screens.fileExchange.toShareThisFile')}
								</p>
							)}
						</InputsSection>
						<ModalButtons
							submitButtonLabel={t('screens.fileExchange.shareFile')}
							onSubmit={handleShareFile}
							cancelButtonLabel={t('screens.fileExchange.cancel')}
							onCancel={onModalClose}
						/>
					</ModalForm>
				</Fragment>
			)}
		</Modal>
	);
};

export default ShareFileModal;
